var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',_vm._g(_vm._b({attrs:{"type":_vm.type,"border":"left","outlined":""}},'v-alert',_vm.$attrs,false),_vm.$listeners),[(_vm.text)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }